module.exports = __webpack_public_path__ + "img/52.1afe6e7c.jpg";